// LLM monitoring queries (P1): summary KPIs + per-view aggregations.
//
// All four queries share one period window and stay enabled together: the
// tabs are cheap bounded aggregates, and switching tabs must not flash a
// loading state for data that is already known.
import { useQuery } from '@tanstack/react-query';

import { useIsPlatformAdmin } from '../../../shared/scope/useCurrentScope.js';

import {
  getAdminLlmByProfile,
  getAdminLlmByWorkspace,
  getAdminLlmQueryKey,
  getAdminLlmSummary,
  getAdminLlmTopConversations,
  type LlmPeriod,
} from '../api/admin.client.js';

export function useAdminLlmSummary(period: LlmPeriod) {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminLlmQueryKey('summary', period),
    queryFn: () => getAdminLlmSummary(period),
    enabled: isPlatformAdmin,
  });
}

export function useAdminLlmByWorkspace(period: LlmPeriod) {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminLlmQueryKey('by-workspace', period),
    queryFn: () => getAdminLlmByWorkspace(period),
    enabled: isPlatformAdmin,
  });
}

export function useAdminLlmByProfile(period: LlmPeriod) {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminLlmQueryKey('by-profile', period),
    queryFn: () => getAdminLlmByProfile(period),
    enabled: isPlatformAdmin,
  });
}

export function useAdminLlmTopConversations(period: LlmPeriod) {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminLlmQueryKey('top-conversations', period),
    queryFn: () => getAdminLlmTopConversations(period),
    enabled: isPlatformAdmin,
  });
}
